module.exports = __webpack_public_path__ + "img/Maskgroup10.9ee7b3e7.png";